// COMMAND: Create this file at src/components/ToolEngine/ToolCanvas/SideBySideCanvas.js

import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import './SideBySideCanvas.css';

const SideBySideCanvas = ({ originalSrc, resultSrc, onDownload }) => {
    return (
        <div className="sbs-layout-wrapper">
            
            {/* LEFT CARD: INPUT */}
            <div className="sbs-card input-card">
                <span className="sbs-badge badge-in">Original</span>
                <div className="sbs-image-box">
                    <img src={originalSrc} alt="Original Input" />
                </div>
            </div>

            {/* CENTER: ARROW */}
            <div className="sbs-arrow-zone">
                <div className="sbs-arrow-circle">
                    <ArrowRight size={28} className="arrow-icon" />
                </div>
            </div>

            {/* RIGHT CARD: OUTPUT */}
            <div className="sbs-card output-card">
                <span className="sbs-badge badge-out">Converted</span>
                <div className="sbs-image-box">
                    <img src={resultSrc} alt="Converted Result" />
                </div>
            </div>

            {/* ACTION */}
            {onDownload && (
                <div className="sbs-actions-bottom">
                    <button onClick={onDownload} className="btn-download-float">
                        <Download size={18} />
                        <span>Download Result</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default SideBySideCanvas;